module.exports = __webpack_public_path__ + "img/pixing_xc5.4a91eb01.jpg";